/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_Resize_HandleInputs */



/**
* | output |
* | --- |
* | "Drag to resize filter panel" |
*
* @param {Editor_Filter_Resize_HandleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_resize_handle = /** @type {((inputs?: Editor_Filter_Resize_HandleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_Resize_HandleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Glisser pour redimensionner le panneau de filtres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ziehen, um das Filterfeld zu vergrößern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascina per ridimensionare il pannello dei filtri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перетащите, чтобы изменить размер панели фильтров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Arrastra para redimensionar el panel de filtros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拖动以调整筛选面板大小")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ドラッグしてフィルターパネルのサイズを変更")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़िल्टर पैनल का आकार बदलने के लिए खींचें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arraste para redimensionar o painel de filtros")
	return /** @type {LocalizedString} */ ("Drag to resize filter panel")
});